module.exports = __webpack_public_path__ + "static/img/smile.619f640.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/smile.png
// module id = J3ug
// module chunks = 0